import { ActionSheetButton, useIonActionSheet } from "@ionic/react";
import { useEffect } from "react";

import CircleButton from "@components/buttons/CircleButton";
import { Opener } from "@hooks/useOpener";
import { IconName } from "@utils/iconUtils";

type Props = {
  buttons: ActionSheetButton<any>[];
  color?: "white" | "primary" | "gray-300" | "gray-150";
  disabled?: boolean;
  icon?: IconName;
  isOpen: boolean;
  opener: Opener;
};

const ActionSheet = ({ buttons, color, disabled, icon, isOpen, opener }: Props) => {
  const [present, dismiss] = useIonActionSheet();

  useEffect(() => {
    if (!isOpen) {
      dismiss();
    }
  }, [isOpen, dismiss]);

  return (
    <CircleButton
      ariaLabelKey="accessibility.ariaLabels.actions"
      color={color ?? "gray-500"}
      data-test="popover-button"
      disabled={disabled}
      fill="clear"
      icon={icon ?? "ellipsis"}
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();

        present({
          buttons,
          mode: "ios"
        });
        opener.open();
      }}
      size="medium"
    />
  );
};

export default ActionSheet;
